import Search from './views/Search.vue';
import Filter from './views/Filter.vue';
import Remarks from './views/Remarks.vue';
import RemarkRules from './views/RemarkRules.vue';
import Fields from './views/Fields.vue';
import Trace from './views/Trace.vue';
import Import from './views/Import.vue';
import RemarkGroups from './views/RemarkGroups.vue';

export default [
  {
    path: 'search',
    component: Search,
    name: '客户搜索',
  },
  {
    path: 'filter',
    component: Filter,
    name: '批量筛选',
  },
  {
    path: 'remarks',
    component: Remarks,
    name: '标签管理',
  },
  {
    path: 'remark-rules',
    component: RemarkRules,
    name: '标签规则',
  },
  {
    path: 'remark-groups',
    component: RemarkGroups,
    name: '标签规则',
  },
  {
    path: 'import',
    component: Import,
    name: '数据导入',
  },
  {
    path: 'fields',
    component: Fields,
    name: '客户字段设置',
  },
  {
    path: 'trace',
    component: Trace,
    name: '客户轨迹',
  },
];
